// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__1YynH","title":"Checkbox_title__3eDoG","desc":"Checkbox_desc__3s8c6"};